import { render, staticRenderFns } from "./Total_Plays.vue?vue&type=template&id=3dcac870&scoped=true"
import script from "./Total_Plays.vue?vue&type=script&lang=js"
export * from "./Total_Plays.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dcac870",
  null
  
)

export default component.exports